import { render, staticRenderFns } from "./WorldZones.vue?vue&type=template&id=8a6d6ba0&"
import script from "./WorldZones.vue?vue&type=script&lang=js&"
export * from "./WorldZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports